
import {makeAutoObservable } from 'mobx'
export interface ActionDialogStoreProps{
    title:string,
    subtitle: string 
    onRightBtnPress: ()=> Promise<void> | void
    rightBtnTxt?:string
    onLeftBtnPress?:()=>void
    leftBtnTxt?:string
    isFullScreen?:boolean,
    type?:"DELETE"| "UPDATE" | "ACTION"
}

const INITIAL_PROPS_STATE:ActionDialogStoreProps={
    title:'',
    subtitle:'', onRightBtnPress:()=>{},
    rightBtnTxt:'Confirm',
    onLeftBtnPress:()=>{},
    leftBtnTxt:'Canel',
    isFullScreen:false,
    type:"ACTION"
}
/**
 * MobX store to manage the state and behavior of an action dialog.
 */
class ActionDialogStore{
    isOpen:boolean=false
    props:ActionDialogStoreProps={...INITIAL_PROPS_STATE}
    isProcessing:boolean=false;
    constructor(){
        makeAutoObservable (this)
    }

      /**
   * Opens the action dialog with the specified properties.
   * @param props - The properties to apply to the action dialog.
   * Default state of props:
   * - `title`: '' (empty string)
   * - `subtitle`: '' (empty string)
   * - `onRightBtnPress`: () => {} (no-op function)
   * - `rightBtnTxt`: 'Confirm'
   * - `onLeftBtnPress`: () => {} (no-op function)
   * - `isFullScreen` :false
   * - `leftBtnTxt`: 'Cancel'
   * - `type`: 'ACTION'
   */
    open(props:ActionDialogStoreProps){
        this.isOpen=true
        this.props={...INITIAL_PROPS_STATE,...props}
    }

     /**
   * Closes the action dialog and resets its properties to their default state.
   */
    close=()=>{
        this.props={...INITIAL_PROPS_STATE}
        this.isOpen=false;
        this.stopProcessing()
    }
    startProcessing=()=>{
        this.isProcessing=true
    }
    stopProcessing=()=>{
        this.isProcessing=false
    }
}


export const actionDialogStore=new ActionDialogStore()